export default "__VITE_ASSET__6424d784__"